import React from "react";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { Alert, Modal, Table } from "antd";
import type { TableColumnsType } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import { useRequest } from "ahooks";
import { ShipWaybillValidateErrorData } from "./getWaybillValidator";

interface ShipValidateErrorModalProps extends InjectBaseModalProps {
    dataSource: ShipWaybillValidateErrorData[];
    canShipOrders: OrderDTO[];
    onContinue: () => void;
    onAbort: () => void;
}

const columns: TableColumnsType<ShipWaybillValidateErrorData> = [
    {
        title: "订单序号",
        key: "orderIndex",
        dataIndex: "orderIndex",
        width: 100,
        render(orderIndex) {
            return <span>{orderIndex + 1}</span>;
        },
    },
    {
        title: "订单编号",
        key: "orderOriginalIds",
        dataIndex: "orderOriginalIds",
        render(orderOriginalIds) {
            return <span style={{ wordBreak: "break-all" }}>{orderOriginalIds}</span>;
        },
    },
    {
        title: "不能发货原因",
        key: "errorMessage",
        dataIndex: "errorMessage",
    },
];

/**
 * 运单号校验不符合规则提示弹框
 */
const ShipValidateErrorModal: React.FC<ShipValidateErrorModalProps> = function (props) {
    const { open, onCancel, dataSource, canShipOrders, onContinue, onAbort } = props;

    const canShipOrderCount = canShipOrders.length;
    const canNotShipOrderCount = dataSource.length;
    const selectOrderCount = canShipOrderCount + canNotShipOrderCount;

    function handleCancel() {
        onAbort();

        onCancel();
    }

    const { runAsync: handleOk, loading } = useRequest(
        async () => {
            try {
                onContinue();
            } catch (error) {}

            onCancel();
        },
        {
            manual: true,
        },
    );

    return (
        <Modal
            width={700}
            open={open}
            onCancel={handleCancel}
            mask={{ closable: false }}
            title="订单发货提示"
            okText="发货剩余订单"
            cancelText="关闭"
            okButtonProps={{
                hidden: !canShipOrders.length,
            }}
            confirmLoading={loading}
            onOk={handleOk}
        >
            <Alert
                className="mb10"
                title={
                    <span>
                        您选中{selectOrderCount}个订单，其中{canShipOrderCount}个订单可发货，
                        <span className="text-error">{canNotShipOrderCount}个</span>订单不符合规则不能发货
                    </span>
                }
                type="warning"
                showIcon
            />

            <Table
                rowKey="orderIndex"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                scroll={{
                    y: 430,
                }}
            />
        </Modal>
    );
};

export default React.memo(ShipValidateErrorModal);
